import { render } from "./TreatmentEditModal.vue?vue&type=template&id=50d5bfba&scoped=true"
import script from "./TreatmentEditModal.vue?vue&type=script&lang=js"
export * from "./TreatmentEditModal.vue?vue&type=script&lang=js"

import "./TreatmentEditModal.vue?vue&type=style&index=0&id=50d5bfba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d5bfba"]])

export default __exports__